import { generatePath } from 'utils/url';

const API_SEARCH_EXPERT = '/sites/:siteSlug/expert_profiles/search';
const API_GET_VALID_TIME_SLOTS = '/sites/:siteSlug/expert_profiles/:expertSlug/valid_time_slots';
const API_CHECK_PROPOSED_TIME = '/sites/:siteSlug/expert_profiles/:expertSlug/time_slot';
const API_CREATE_CALL_REQUEST = '/sites/:siteSlug/call_requests';
const API_GET_SCHEDULING_DATA = '/sites/:siteSlug/expert_profiles/:expertSlug/schedule';
const API_CREATE_PACKAGE = '/sites/:siteSlug/bundle_requests';
export const API_SEARCH_ORGANIZATIONS = '/organizations';
const API_GET_ORGANIZATION = '/organizations/:organizationSlug';
export const API_GET_ORGANIZATION_SCHEMA = '/sites/organization_schema';
export const API_GET_FUNDRAISER_TEMPLATE = '/sites/fundraiser_template';
export const API_PURCHASE_PRODUCT_CREDITS = '/product_credits';

export const API_GET_INVENTORIES = '/inventories';
export const API_GET_INVENTORY_PRODUCTS = '/inventories/:inventoryId/inventory_products';
const API_GET_INVENTORY_AVAILABLE_WALLETS = '/inventories/:inventoryId/available_wallets';
export const API_CREATE_ORDER = '/orders';
export const API_STRIPE_CURRENCIES = '/stripe_currencies';
export const API_GET_EXCHANGE_RATES = '/stripe_currencies/exchange_rates';

export const API_URL = `${import.meta.env.VITE_SYSTEM_DOMAIN}/api`;
export const PIGGY_BACKR_API_BASE_URL = `${import.meta.env.VITE_PIGGY_BACKR_DOMAIN}/api`;
export const ADMIN_API_URL = `${import.meta.env.VITE_SYSTEM_DOMAIN}/admin_api`;

export const API_ROOT_SITE_PATH = '/sites';
export const API_CHILD_SITE_PATH = '/sites/:siteSlug';
export const API_GET_SITE_VISIBLE_KEYWORDS = '/keywords';
export const API_GET_CONTENTS = '/contents';
export const API_SIGN_IN = '/users/sign_in';
export const API_SIGN_UP = '/users';
export const API_GET_CURRENT_USER = '/users/current';
export const API_SIGN_OUT = '/users/sign_out';
export const API_GET_CURRENT_SPECIFIC_SITE = '/users/current/specific_site';
export const API_CREATE_MEMBERSHIP = '/memberships';
export const API_GET_ACCOUNT_SETTINGS = '/account_settings';
export const API_UPDATE_USER_PROFILE = '/account_settings/update_profile';
export const API_GET_USER_PHONES_FOR_SITE = '/phone_numbers';
export const API_SET_DEFAULT_PHONE_FOR_SITE = '/phone_numbers/set_default';
export const API_UPDATE_PASSWORD = '/account_settings/update_password';
export const API_USER_PICTURE_SETTING = '/account_settings/avatars';
export const API_UPDATE_USER_PREFERENCES = '/account_settings/preferences';
export const API_UPDATE_USER_TERMS_SETTING = '/account_settings/accept_terms';
export const API_CREATE_PAYMENT_METHOD = '/account_settings/create_payment_method';
export const API_UPDATE_PAYMENT_METHOD = '/account_settings/update_payment_method';
export const API_CREATE_RECOMMEND_KEYWORDS = '/keyword_recommendations';
export const API_COMMENTS_FOR_CALL_REQUEST = '/comments';
export const API_CONFIRM_USER = '/users/confirmation';
export const API_USER_PASSWORD = '/users/password';
export const API_FEEDBACK_FOR_SITE = '/feedbacks';
export const API_EXPERT_VOLUNTEERINGS = '/expert_volunteerings';
export const API_VOLUNTEERING_SITES = '/sites/volunteering_sites';
export const API_SIGN_IN_WITH_TOKEN = '/users/sign_in_with_token';
export const API_DETECT_AUTHENTICATED_USER = '/users/detect_authenticated_user';
export const API_VISIT_ONBOARDING_STEP = '/users/current/visit_onboarding_step';
export const API_COMPLETE_REGISTRATION = '/users/current/complete_registration';
export const API_UPDATE_CHECKLIST_TASKS_FOR_CALL_REQUEST = '/checklist_tasks/update_for_call_request';

export const API_UPDATE_TRACKING_AUTHENTICATION = '/users/current/track_authentication';
export const API_GET_CURRENT_SIGN_IN_AT = '/users/current/current_sign_in_at';
export const API_GET_ONBOARDING_CHARITY_CONTRIBUTION = '/memberships/onboarding_charity_contribution';
export const API_DECLINE_TEST_CALL = '/users/current/decline_test_call';
export const API_SCHEDULE_TEST_CALL = '/test_call_requests';
export const API_REPORT_CALL_REQUEST = '/call_request_reports';
export const API_GET_CONTENT_DOWNLOAD_APP_PAGE = '/contents/download_app_page';
export const API_GET_DOWNLOAD_APP_MESSAGES = '/contents/download_app_messages';
export const API_GET_SESSIONS_CONTENTS = '/contents/sessions';
export const API_GET_SITE_AVAILABLE_CHARITIES_FOR_RECOMMENDATION = '/sites/available_charities_for_recommendation';
export const API_GET_SITE_CUSTOM_PAGES = '/custom_pages';
export const API_GET_NOTIFICATIONS = '/notifications';
export const API_GET_UNREAD_NOTIFICATION_COUNT = '/notifications/unread_count';
export const API_MARK_AS_READ_ALL_NOTIFICATION = '/notifications/mark_as_read_all';
export const API_JOIN_SESSION = '/sites/:siteSlug/sessions/:callRequestSlug/:action?';
export const API_GET_EVENTS = '/custom_pages/events';
export const API_GET_FEATURED_EVENTS = '/custom_pages/featured_events';
export const API_GET_EVENT_TAGS = '/event_tags';
export const API_GET_ORGANIZATION_TAGS = '/organization_tags';
export const API_USER_SSO = '/users/sso';
export const API_AUTHENTICATIONS = '/authentications';
export const API_AUTHENTICATION_AUTHORIZE_URL = '/authentications/authorize_url';
export const API_AUTHENTICATION_ACCESS_TOKEN = '/authentications/access_token';
export const API_AUTHENTICATION_SIGN_IN_URL = '/authentications/sign_in_url';
export const API_TEAM_USERS = '/users';
const API_TEAM_USER_DETAILS = '/users/:userSlug';
export const API_GET_SITE_ASSOCIATIONS = '/sites/associations';
export const API_GET_DESIGN_PATHS = '/sites/design_paths';
const API_GET_SESSION_LIBRARY = '/sites/:siteSlug/call_types/library';
const API_GET_SESSION_LIBRARY_DETAILS = '/sites/:siteSlug/call_types/library/:id';
export const API_USER_CHATBOT_MESSAGES = '/chatbot_messages';
export const API_GET_CUSTOM_PAGE_OVERLAY_IDS = '/custom_pages/overlay';

export const API_ADMIN_CUSTOM_PAGES = '/admin/custom_pages';
export const API_ADMIN_REFRESH_TOKEN = '/admin/refresh_token';
export const API_ADMIN_FRONTEND_TEMPLATES = '/admin/frontend_templates';
export const API_ADMIN_FRONTEND_TEMPLATE = '/admin/frontend_templates/:id';
export const API_ADMIN_CUSTOM_PAGE = '/admin/custom_pages/:id';
export const API_ADMIN_TEMPLATE_BLOCKS = '/admin/template_blocks';
export const API_ADMIN_SITES = '/sites';
export const API_ADMIN_SITE = '/admin/sites/:siteId';
export const API_ADMIN_UPDATE_SITE_SIDEBAR_MENU = '/admin/sites/:siteId/update_sidebar_menu';
export const API_ADMIN_GET_SITE_SIDEBAR_MENU = '/admin/sites/:siteId/sidebar_menu';
export const API_ADMIN_GET_SITE_HORIZONTAL_NAVIGATION = '/admin/sites/:siteId/horizontal_navigation';
export const API_ADMIN_UPDATE_SITE_HORIZONTAL_NAVIGATION = '/admin/sites/:siteId/update_horizontal_navigation';
export const API_ADMIN_VALIDATE_CUSTOM_PAGE = '/admin/custom_pages/validate_name';
export const API_ADMIN_DEFAULT_BLOCK_CONTENT = '/admin/template_block_sample_contents';
export const API_ADMIN_UPDATE_DEFAULT_BLOCK_CONTENT_IMAGE = '/admin/template_block_sample_contents/:id/update_image';
export const API_ADMIN_CURRENCY_TYPES = '/currency_types';

// Surveys
export const API_GET_SURVEYS = '/surveys';
export const buildApiSubmitSurveyResponse = (surveyId) => `/surveys/${surveyId}/survey_responses`;
export const buildApiSessionSurveyResponse = (callRequestId) =>
  `/call_requests/${callRequestId}/session_survey_response`;

// Piggybackr API
export const API_GET_EXPERT_FUNDRAISERS = '/fundraisers';
export const API_GET_PUBLIC_FUNDRAISERS = '/fundraisers/readonly';
export const API_GET_FEATURED_FUNDRAISERS = '/fundraisers/featured';
export const API_GET_LAUNCHED_FUNDRAISERS = '/fundraisers/launched';
export const API_CREATE_STRIPE_CHECKOUT_SESSION = '/stripe_checkout_sessions';
export const API_CREATE_DONATION = '/donations';
const API_GET_DONATION = '/donations/:id';

// Admin API
export const API_ADMIN_CONTENTS_BATCH_UPDATE = '/contents/batch_update';
export const API_ADMIN_SIDEBAR_MENU = '/sidebar_menu';
export const API_ADMIN_DESIGN_ITEMS = '/sidebar_menu/design_items';
export const API_ADMIN_DOCUMENTS = '/documents';
export const API_ADMIN_DOCUMENT = '/documents/:id';

export const API_ADMIN_BLOCK_LIBRARIES = '/block_libraries';
export const API_ADMIN_ARCHIVE_CONTENT_BLOCK = '/block_libraries/archive_content_block';
export const API_ADMIN_RESTORE_BLOCK_LIBRARY = '/block_libraries/restore';
export const API_ADMIN_ARCHIVE_BLOCK_LIBRARY = '/block_libraries/archive';
export const API_ADMIN_CLONE_BLOCK_TO_LIBRARY = '/block_libraries/clone_blocks_to_libraries';
export const API_ADMIN_UPDATE_BLOCKS_FEATURED = '/block_libraries/bulk_update_featured';
export const API_ADMIN_UPDATE_BLOCKS_LOCKED = '/block_libraries/bulk_update_locked';
export const API_ADMIN_UPDATE_BLOCKS_HIDDEN = '/block_libraries/bulk_update_hidden';
export const API_ADMIN_UPDATE_BLOCKS_REPLACE_URLS = '/block_libraries/bulk_update_replace_urls';
export const API_ADMIN_RESEARCH_BLOCKS = '/research_blocks';
export const API_ADMIN_RESEARCH_BLOCK = '/research_blocks/:id';
export const API_ADMIN_CLONE_RESEARCH_BLOCKS_TO_LIBRARY = '/research_blocks/clone_blocks_to_library';
export const API_ADMIN_BLOCK_LIBRARY = '/block_libraries/:id';
export const API_ADMIN_UPDATE_OWNER_NETWORK = '/block_libraries/update_owner_network';
export const API_ADMIN_PAGE_LIBRARY = '/custom_pages/library';
export const API_ADMIN_CONTENTS = '/contents';
export const API_ADMIN_GET_CURRENT_ADMIN = '/admins/current';
export const API_ADMIN_GET_CHATBOTS = '/chatbot_configurations';

export const API_ADMIN_TABLE_CONFIGURATIONS = '/admins/table_configurations';
export const API_ADMIN_UPDATE_TABLE_CONFIGURATION = '/admins/table_configurations/:tableId';

export const buildApiSearchExpertPath = (siteSlug) => API_SEARCH_EXPERT.replace(':siteSlug', siteSlug);
export const buildApiValidTimeSlots = (siteSlug, expertSlug) =>
  API_GET_VALID_TIME_SLOTS.replace(':siteSlug', siteSlug).replace(':expertSlug', expertSlug);
export const buildApiCheckProposedTime = (siteSlug, expertSlug) =>
  API_CHECK_PROPOSED_TIME.replace(':siteSlug', siteSlug).replace(':expertSlug', expertSlug);
export const buildApiGetSchedulingData = (siteSlug, expertSlug) =>
  API_GET_SCHEDULING_DATA.replace(':siteSlug', siteSlug).replace(':expertSlug', expertSlug);
export const buildApiCreateCallRequest = (siteSlug) => API_CREATE_CALL_REQUEST.replace(':siteSlug', siteSlug);
export const buildApiCreatePackage = (siteSlug) => API_CREATE_PACKAGE.replace(':siteSlug', siteSlug);
export const buildApiPurchaseGiftCard = (siteSlug) => `/sites/${siteSlug}/gift_cards`;
export const buildApiGetGiftCardInfo = (siteSlug, redemptionCode) =>
  `/sites/${siteSlug}/gift_cards/${redemptionCode}/success`;
export const buildApiGiftCardCancel = (siteSlug, redemptionCode) =>
  `/sites/${siteSlug}/gift_cards/${redemptionCode}/cancel`;
export const buildApiRedeemGiftCard = (siteSlug, redemptionCode) =>
  `/sites/${siteSlug}/gift_cards/${redemptionCode}/redeem`;
export const buildGetGiftCardAppearances = (siteSlug, expertSlug) =>
  expertSlug
    ? `/sites/${siteSlug}/expert_profiles/${expertSlug}/gift_card_appearances`
    : `/sites/${siteSlug}/gift_card_appearances`;
export const buildApiGetExpertProfile = (siteSlug, expertSlug) => `/sites/${siteSlug}/expert_profiles/${expertSlug}`;
export const buildApiDeleteAvatar = (id) => `${API_USER_PICTURE_SETTING}/${id}`;
export const buildApiUpdateAvatar = (id) => `${API_USER_PICTURE_SETTING}/${id}`;
export const buildApiGetExpertSettings = (siteSlug) => `/sites/${siteSlug}/expert_settings`;
export const buildApiGetCurrentCalls = (siteSlug) => `/sites/${siteSlug}/calls/current`;
export const buildApiUpdateExpertDetailsSettings = (siteSlug) =>
  `${buildApiGetExpertSettings(siteSlug)}/expert_details`;
export const buildApiGetExpertGlobalSettings = (siteSlug) => `/sites/${siteSlug}/expert_global_settings`;
export const buildApiUpdateExpertVacationMode = (siteSlug) =>
  `${buildApiGetExpertGlobalSettings(siteSlug)}/vacation_mode`;
export const buildApiGetPastCalls = (siteSlug) => `/sites/${siteSlug}/calls/past`;
export const buildApiGetWaitlistedCalls = (siteSlug) => `/sites/${siteSlug}/calls/waitlisted`;
export const buildApiPatchExpertAvailabilitySettings = (siteSlug) => `/sites/${siteSlug}/expert_settings/availability`;
export const buildApiTimeSlotSetting = (siteSlug) => `/sites/${siteSlug}/time_slots`;
export const buildApiDeleteTimeSlot = (siteSlug, id) => `${buildApiTimeSlotSetting(siteSlug)}/${id}`;
export const buildApiGetCompletedCalls = (siteSlug) => `/sites/${siteSlug}/calls/completed`;
export const buildApiToggleMessaging = (siteSlug, id) => `/sites/${siteSlug}/call_requests/${id}/toggle_messaging`;
export const buildApiRequestingMessaging = (siteSlug, id) => `/sites/${siteSlug}/call_requests/${id}/request_messaging`;
export const buildApiCalendarConnections = (siteSlug) => `/sites/${siteSlug}/calendar_connections`;
export const buildApiUpdateCalendarConnections = (siteSlug) =>
  `${buildApiCalendarConnections(siteSlug)}/update_configurations`;
export const buildApiDeleteCalendarConnection = (siteSlug, id) => `${buildApiCalendarConnections(siteSlug)}/${id}`;
export const buildApiUpdateGiftCardSetting = (siteSlug) => `${buildApiGetExpertSettings(siteSlug)}/gift_card`;
export const buildApiGetGiftCardHistories = (siteSlug) => `${buildApiGetExpertSettings(siteSlug)}/gift_card_histories`;
export const buildApiSessionSettings = (siteSlug) => `/sites/${siteSlug}/call_types`;
export const buildApiDeleteSession = (siteSlug, id) => `${buildApiSessionSettings(siteSlug)}/${id}`;
export const buildApiUpdateSession = (siteSlug, id) => `${buildApiSessionSettings(siteSlug)}/${id}`;
export const buildApiUpdateSessionSettings = (siteSlug) => `${buildApiGetExpertSettings(siteSlug)}/session`;
export const buildApiSessionPackSettings = (siteSlug) => `/sites/${siteSlug}/call_type_bundles`;
export const buildApiSessionPackDetails = (siteSlug, id) => `${buildApiSessionPackSettings(siteSlug)}/${id}`;
export const buildApiUpdatePayoutMethod = (siteSlug) => `${buildApiGetExpertSettings(siteSlug)}/payout_method`;
export const buildApiExpertSignUp = (siteSlug) => `${siteSlug}/experts`;
export const buildApiCancelCallRequest = (siteSlug, id) => `/sites/${siteSlug}/call_requests/${id}/cancel`;
export const buildApiDeclineCallRequest = (siteSlug, id) => `/sites/${siteSlug}/call_requests/${id}/decline`;
export const buildApiAcceptCallRequest = (siteSlug, id) => `/sites/${siteSlug}/call_requests/${id}/accept`;
export const buildApiBounceCallRequest = (siteSlug, id) => `/sites/${siteSlug}/call_requests/${id}/bounce`;
export const buildApiRefundCallRequest = (siteSlug, id) => `/sites/${siteSlug}/call_requests/${id}/refund`;
export const buildApiFinishCallRequest = (siteSlug, id) => `/sites/${siteSlug}/call_requests/${id}/finish`;
export const buildApiCallRequest = (siteSlug, id) => `/sites/${siteSlug}/call_requests/${id}`;
export const buildApiAcceptFirstWaitlist = (siteSlug, id) =>
  `/sites/${siteSlug}/call_types/${id}/promote_waitlisted_call`;
export const buildApiDeclineFirstWaitlist = (siteSlug, id) =>
  `/sites/${siteSlug}/call_types/${id}/decline_first_waitlisted_call`;
export const buildApiDeclineAllWaitlist = (siteSlug, id) =>
  `/sites/${siteSlug}/call_types/${id}/decline_all_waitlisted_calls`;
export const buildApiGetCalendarConnectionUrl = (siteSlug) =>
  `/sites/${siteSlug}/expert_profiles/url_for_calendar_connection`;
export const buildApiEnableRescheduleCallRequest = (siteSlug, id) =>
  `/sites/${siteSlug}/call_requests/${id}/enable_reschedule`;
export const buildApiGetZoomConnectionUrl = (siteSlug) => `/sites/${siteSlug}/expert_profiles/url_for_zoom_connection`;
export const buildApiDisconnectZoomAccount = (siteSlug) =>
  `${buildApiGetExpertSettings(siteSlug)}/disconnect_zoom_account`;
export const buildApiUpdateZoomConfigurations = (siteSlug) =>
  `${buildApiGetExpertSettings(siteSlug)}/update_zoom_account`;
export const buildApiEnableZoomCoHost = (siteSlug) =>
  `${buildApiGetExpertSettings(siteSlug)}/enable_co_host_zoom_account`;
export const buildApiZoomConnection = (siteSlug) => `/sites/${siteSlug}/expert_settings/zoom_account`;
export const buildApiGetExpertSessionsForSetting = (siteSlug) => `/sites/${siteSlug}/expert_settings/call_types`;
export const buildApiGetExpertPackagesForSetting = (siteSlug) => `/sites/${siteSlug}/expert_settings/call_type_bundles`;
export const buildApiUpdateCurrencyLimitations = (siteSlug) =>
  `${buildApiGetExpertSettings(siteSlug)}/currency_limitations`;
export const buildApiExpertVolunteering = (id) => `${API_EXPERT_VOLUNTEERINGS}/${id}`;
export const buildApiPauseExpertVolunteering = (id) => `${buildApiExpertVolunteering(id)}/pause`;
export const buildApiResumeExpertVolunteering = (id) => `${buildApiExpertVolunteering(id)}/resume`;
export const buildApiArchiveExpertVolunteering = (id) => `${buildApiExpertVolunteering(id)}/archive`;
export const buildApiExpertSubmitOnboarding = (siteSlug) => `/sites/${siteSlug}/expert_profiles/submit`;
export const buildApiUpdateExpertVisibility = (siteSlug) => `${buildApiGetExpertSettings(siteSlug)}/visibility`;
export const buildApiGetExpertStripeAccountUrl = (siteSlug) =>
  `${buildApiGetExpertSettings(siteSlug)}/stripe_account_url`;
export const buildApiExpertApproveProfile = (siteSlug) => `/sites/${siteSlug}/expert_profiles/approve_by_expert`;
export const buildApiUpdateCharityContribution = (siteSlug) =>
  `/sites/${siteSlug}/expert_settings/charity_contribution`;
export const buildApiGetCharityContributionSessions = (siteSlug) =>
  `/sites/${siteSlug}/expert_profiles/charity_contribution_sessions`;
export const buildApiGetExpertInPersonMeetingLocations = (siteSlug) => `/sites/${siteSlug}/in_person_meeting_locations`;
export const buildApiUpdateExpertInPersonMeetingLocations = (siteSlug) =>
  `/sites/${siteSlug}/expert_settings/in_person_meeting_locations`;
export const buildApiConfirmInPersonCallRequest = (siteSlug, id) =>
  `${buildApiCallRequest(siteSlug, id)}/confirm_in_person`;
export const buildApiChangeCallRequestLocation = (siteSlug) => `/sites/${siteSlug}/call_request_locations`;
export const buildApiGetInPersonMeetingLocationsForScheduling = (siteSlug) =>
  `/sites/${siteSlug}/in_person_meeting_locations/for_scheduling`;
export const buildApiCreateGiftCardAppearance = (siteSlug) => `/sites/${siteSlug}/gift_card_appearances`;
export const buildApiUpdateGiftCardAppearance = (siteSlug, id) => `/sites/${siteSlug}/gift_card_appearances/${id}`;
export const buildApiDeleteGiftCardAppearance = (siteSlug, id) => `/sites/${siteSlug}/gift_card_appearances/${id}`;
export const buildApiGetTestCallRequests = (siteSlug) => `/test_call_requests?siteSlug=${siteSlug}`;
export const buildApiGetExpertVisibleSessions = (siteSlug, expertSlug) =>
  `/sites/${siteSlug}/expert_profiles/${expertSlug}/call_types`;
export const buildApiGetExpertVisiblePackages = (siteSlug, expertSlug) =>
  `/sites/${siteSlug}/expert_profiles/${expertSlug}/call_type_bundles`;
export const buildApiGetExpertAvailableStripeAccounts = (siteSlug) =>
  `/sites/${siteSlug}/expert_global_settings/available_stripe_accounts`;
export const buildApiExpertRecommendCharities = (siteSlug) => `/sites/${siteSlug}/expert_settings/recommend_charities`;
export const buildApiGetExpertBadges = (siteSlug) => `/sites/${siteSlug}/expert_badges`;
export const buildApiGetCustomPage = (id) => `/custom_pages/${id}`;
export const buildApiSearchingSessions = (siteSlug) => `/sites/${siteSlug}/expert_profiles/search_by_call_type_name`;
export const buildApiCreateVerification = (countryId) => `/phone_numbers/${countryId}/create_verification`;
export const buildApiVerifyPhone = (countryId) => `/phone_numbers/${countryId}/verify`;
export const buildApiMarkAsReadNotification = (id) => `/notifications/${id}/mark_as_read`;
export const buildApiChatbotMessage = (id) => `${API_USER_CHATBOT_MESSAGES}/${id}`;

export const buildApiGetOrganization = (organizationSlug) =>
  API_GET_ORGANIZATION.replace(':organizationSlug', organizationSlug);
export const buildApiGetOrganizationTags = (siteId) => `/sites/${siteId}/organization_tags`;

export const buildApiAdminUpdateContentImage = (id) => `${API_ADMIN_CUSTOM_PAGES}/${id}/update_content_image`;

export const buildExpertProfileScriptSnippetLink = (expertProfileId, buttonName) => {
  const params = new URLSearchParams();

  params.append('expert_profile_id', expertProfileId);
  params.append('button_name', buttonName);

  return `${import.meta.env.VITE_SYSTEM_DOMAIN}/script_snippets/public_expert_profile_url?${params.toString()}`;
};
export const buildApiJoinSession = (siteSlug, callRequestSlug, options = {}) =>
  generatePath(API_JOIN_SESSION, { ...options, siteSlug, callRequestSlug });

export const buildApiJoinSessionCallback = (siteSlug, callRequestSlug) =>
  generatePath(API_JOIN_SESSION, { siteSlug, callRequestSlug, action: 'join' });

export const buildApiLeaveSessionCallback = (siteSlug, callRequestSlug) =>
  generatePath(API_JOIN_SESSION, { siteSlug, callRequestSlug, action: 'leave' });

export const buildApiTrackSessionStatus = (siteSlug, callRequestSlug) =>
  generatePath(API_JOIN_SESSION, { siteSlug, callRequestSlug, action: 'status' });
export const buildApiGetUserDetails = (userSlug) => generatePath(API_TEAM_USER_DETAILS, { userSlug });
export const buildApiGetSessionLibrary = (siteSlug) => generatePath(API_GET_SESSION_LIBRARY, { siteSlug });
export const buildApiGetSessionLibraryDetails = (siteSlug, id) =>
  generatePath(API_GET_SESSION_LIBRARY_DETAILS, { siteSlug, id });

export const buildApiAdminFrontendTemplate = (id) => generatePath(API_ADMIN_FRONTEND_TEMPLATE, { id });
export const buildApiAdminCustomPage = (id) => generatePath(API_ADMIN_CUSTOM_PAGE, { id });
export const buildApiAdminGetSite = (siteId) => generatePath(API_ADMIN_SITE, { siteId });
export const buildApiAdminGetSidebarMenu = (siteId) => generatePath(API_ADMIN_GET_SITE_SIDEBAR_MENU, { siteId });
export const buildApiAdminUpdateSidebarMenu = (siteId) => generatePath(API_ADMIN_UPDATE_SITE_SIDEBAR_MENU, { siteId });
export const buildApiAdminGetHorizontalNavigation = (siteId) =>
  generatePath(API_ADMIN_GET_SITE_HORIZONTAL_NAVIGATION, { siteId });
export const buildApiAdminUpdateHorizontalNavigation = (siteId) =>
  generatePath(API_ADMIN_UPDATE_SITE_HORIZONTAL_NAVIGATION, { siteId });
export const buildApiAdminUpdateDefaultBlockContentImage = (id) =>
  generatePath(API_ADMIN_UPDATE_DEFAULT_BLOCK_CONTENT_IMAGE, { id });
export const buildApiAdminDocument = (id) => generatePath(API_ADMIN_DOCUMENT, { id });
export const buildApiAdminBlockLibrary = (id) => generatePath(API_ADMIN_BLOCK_LIBRARY, { id });
export const buildApiAdminResearchBlock = (id) => generatePath(API_ADMIN_RESEARCH_BLOCK, { id });
export const buildApiAdminCustomPageAuthLogs = (id) => generatePath('/admin/custom_pages/:id/audit_logs', { id });

export const buildApiAdminUpdateBlockDocumentImage = (id) =>
  generatePath('/block_libraries/:id/update_content_image', { id });
export const buildApiAdminGetBlockLibraryUsage = (id) => generatePath('/block_libraries/:id/blocks', { id });
export const buildApiAdminUpdateSiteConfig = (siteId) => generatePath('/sites/:siteId', { siteId });
export const buildApiAdminUpdateContent = (id) => generatePath('/contents/:id', { id });
export const buildApiAdminUpdateTableConfiguration = (tableId) =>
  generatePath(API_ADMIN_UPDATE_TABLE_CONFIGURATION, { tableId });

export const API_ADMIN_LIBRARY_TAGS_FOR_APPLICATION = '/library_tags/for_application';

const ADMIN_LIBRARY_TAGS_BATCH_SEGMENT = {
  BlockLibrary: 'block_libraries',
  CustomPage: 'custom_pages',
  Site: 'library_sites',
};

export const buildAdminLibraryTagsBatchPath = (taggableType) => {
  const segment = ADMIN_LIBRARY_TAGS_BATCH_SEGMENT[taggableType];
  if (!segment) throw new Error(`No library_tags batch endpoint for taggableType=${taggableType}`);
  return `/${segment}/library_tags`;
};

export const buildApiGetFundraiserData = (username, fundraiserSlug) =>
  generatePath('/users/:username/fundraisers/:fundraiserSlug', { username, fundraiserSlug });
export const buildApiGetDonationPath = (id) => generatePath(API_GET_DONATION, { id });
export const buildApiGetFundraiserActivities = (username, fundraiserSlug) =>
  generatePath('/users/:username/fundraisers/:fundraiserSlug/activities', { username, fundraiserSlug });

export const buildApiGetInventory = (id) => generatePath('/inventories/:id', { id });
export const buildApiGetInventoryAvailableWallets = (inventoryId) =>
  generatePath(API_GET_INVENTORY_AVAILABLE_WALLETS, { inventoryId });
